// extracted by mini-css-extract-plugin
export var solutions__list = "solutions-module--solutions__list--gVS5s";
export var solutions__link = "solutions-module--solutions__link--oG7y0";
export var solutions__linkIcon = "solutions-module--solutions__linkIcon--BHBEe";
export var solutions__more = "solutions-module--solutions__more--3mPNo";
export var solutions__button = "solutions-module--solutions__button--d7urz";
export var solutions = "solutions-module--solutions--cVMC2";
export var solutions__list_showall = "solutions-module--solutions__list_showall--rb0P5";